<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import Socialmedia from "../../../Data/ComponentData/WidgetData/Genral/SocialMedia.json";
  import Card from "../../Core/Card.svelte";
</script>

{#each Socialmedia.Socialmediadata as Social}
  <Col sm="6" xl="3" lg="6" class="xl-25 box-col-6">
    <Card cardProps="social-widget-card">
      <div slot="contentbody">
        <div class="redial-social-widget radial-bar-70" data-label="50%">
          <i class="{Social.icon} font-primary" />
        </div>
        <h5 class="b-b-light">{Social.name}</h5>
        <Row>
          {#each Social.children as socialItem}
            <Col class="text-center">
              <span>{socialItem.review}</span>
              <h4 class="counter mb-0">{socialItem.count}</h4>
            </Col>
          {/each}
        </Row>
      </div>
    </Card>
  </Col>
{/each}
